import React, {useEffect, useState} from "react";
import {ModalProps} from "antd/lib/modal";
import {Modal, Upload} from "antd";
import {InboxOutlined} from "@ant-design/icons";
import {RcFile} from "antd/lib/upload/interface";

interface UploadModalProps extends ModalProps {
    onUpload: (file: File) => void
    template?: string
}

function UploadModal(props: UploadModalProps) {
    const {onUpload, template, ...otherProps} = props
    const [file, setFile] = useState<RcFile[]>([])

    useEffect(() => {
        if (otherProps.open) {
            setFile([])
        }
    }, [otherProps.open])

    function beforeUpload(file: RcFile) {
        setFile([file])
        return false
    }

    function onOk() {
        if (file.length > 0 && onUpload) {
            onUpload(file[0])
        }
    }

    return (
        <Modal {...otherProps} onOk={onOk}>
            <Upload.Dragger beforeUpload={beforeUpload} fileList={file}>
                <p className="ant-upload-drag-icon">
                    <InboxOutlined/>
                    <p className="ant-upload-text">点击或拖放文件到此处上传</p>
                    {template && (
                        <a className="ant-upload-text" href={template} target={'_blank'}
                           onClick={event => event.stopPropagation()}>
                            文件模板
                        </a>
                    )}
                </p>
            </Upload.Dragger>
        </Modal>
    )
}

export default UploadModal
